import * as React from 'react';
import * as moment from 'moment-timezone';
import { getTime, compareFormat } from '../../../../utils/momentUtils';
import { st, classes } from './TimeRenderer.st.css';
import WeeklyContext from '../../../../context/weeklyContext';
import WixStylesContext from '../../../../context/wixStylesContext';
var TimeRenderer = function (_a) {
    var event = _a.event, lessOneHour = _a.lessOneHour;
    var _b = React.useContext(WixStylesContext), isTimeShown = _b.isTimeShown, is24format = _b.is24format;
    var isMobile = React.useContext(WeeklyContext).isMobile;
    var isAllDay = event.extendedProps.isAllDay;
    var pastEvent = event.extendedProps.pastEvent;
    var momentStartTime = moment(event.start);
    var momentEndTime = moment(event.end);
    var start = getTime(is24format, 
    //@ts-ignore
    momentStartTime.subtract(momentStartTime._offset, 'minutes'));
    var end = getTime(is24format, 
    //@ts-ignore
    momentEndTime.subtract(momentEndTime._offset, 'minutes'));
    if (!is24format) {
        start = compareFormat(start, end);
    }
    return (React.createElement(React.Fragment, null, isTimeShown &&
        !isAllDay &&
        (!lessOneHour ? (React.createElement("div", { className: st(classes.TimeRenderer, { pastEvent: pastEvent, isMobile: isMobile }) },
            ' ',
            start,
            " - ",
            end)) : (React.createElement("span", { className: st(classes.TimeRenderer, { pastEvent: pastEvent, isMobile: isMobile }) },
            start,
            " - ",
            end)))));
};
export default TimeRenderer;
//# sourceMappingURL=TimeRenderer.js.map